import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Footer {
    constructor(container) {
        this.container = container;
        this.mm = gsap.matchMedia();

        this.init();
    }

    init = () => {
        // Let gsap.matchMedia + invalidateOnRefresh own the resize lifecycle.
        // ScrollTrigger recalculates the reveal on every refresh and always drives
        // the footer's transform from the scroll position, so it's never left in a
        // half-applied state — which is what dropped the footer content on
        // resize/load with the old manual clearProps/kill/recreate approach.
        //
        // No manual resize -> refresh here: ScrollTrigger already refreshes
        // itself on window resize, and on touch devices it deliberately ignores
        // the resize the browser toolbar fires while scrolling. A manual call
        // bypassed that and ran a full refresh mid-scroll on every page.
        this.mm.add(
            {
                isMobile: '(max-width: 1499px)',
                isDesktop: '(min-width: 1500px)',
            },
            (context) => {
                const { isMobile } = context.conditions;

                const reveal = gsap.fromTo(
                    'footer',
                    { yPercent: isMobile ? -15 : -50 },
                    { yPercent: 0, ease: 'none' }
                );

                ScrollTrigger.create({
                    trigger: '.shopify-section-group-footer-group',
                    start: 'top bottom',
                    end: isMobile ? '100px' : 'max',
                    animation: reveal,
                    scrub: true,
                    invalidateOnRefresh: true,
                });

                // Reset the footer transform when the breakpoint changes / context
                // reverts (the tween + ScrollTrigger are cleaned up by matchMedia).
                return () => {
                    gsap.set('footer', { clearProps: 'all' });
                };
            }
        );
    };
}
